export const translations = {
  en: {
    // Existing translations
    faceVerification: "Face Verification",
    passportVerification: "Passport Verification",
    nationalIdLabel: "National ID Number",
    nationalIdPlaceholder: "Enter your national ID",
    enterNationalId: "Please enter your national ID",
    startLiveness: "Start Liveness Check",
    capturePhoto: "Capture Photo",
    nextStep: "Next Step: Passport Verification",
    retry: "Retry",
    challengeTitle: "Liveness Challenge",
    challengeListTitle: "Challenge Progress",
    turnLeft: "Turn your head LEFT",
    turnRight: "Turn your head RIGHT",
    blinkTwice: "Blink TWICE",
    keepTurning: "Keep turning!",
    blinksProgress: "Blinks:",
    initializing: "Initializing camera...",
    loading: "Loading AI model...",
    ready: "Ready! Enter ID and start liveness check",
    noFace: "No face detected",
    challengeComplete: "Challenge Complete!",
    allComplete: "All checks passed! Ready to capture",
    uploading: "Uploading...",
    success: "Verification successful!",
    failed: "Verification failed",
    timeout: "Timeout! Try again",
    cameraError: "Camera access denied",
    yaw: "YAW",
    pitch: "PITCH",
    roll: "ROLL",
    blinks: "BLINKS",
    
    title: "Passport Capture",
    subtitle: "Scan your passport for verification",
    instructionsTitle: "Instructions",
    instruction1: "Place your passport on a flat, well-lit surface",
    instruction2: "Use the camera or upload an image",
    instruction3: "Adjust the red (photo) and blue (MRZ) boxes if needed",
    instruction4: "Capture and submit for verification",
    captureBtn: "Capture",
    uploadBtn: "Upload",
    submitBtn: "Submit",
    statusInit: "Camera ready. Position your passport.",
    statusCapturing: "Capturing image...",
    statusProcessing: "Processing upload...",
    statusSubmitting: "Submitting for verification...",
    statusSuccess: "Verification successful!",
    statusCameraError: "Camera error",
    previewTitle: "Preview - Verify and Submit",
    
    livenessTitle: "Liveness Verification",
    livenessSubtitle: "Step 3 of 3: Video Recording",
    recordingLangLabel: "Recording Language:",
    instrTitle: "Instructions:",
    instructions: [
      "Read the text below clearly and loudly",
      "Ensure your face is visible in the frame",
      "Use a quiet environment with good lighting",
      "Recording will last up to 30 seconds",
      "You can retry multiple times until satisfied",
      "Note: Read the text in the language you selected"
    ],
    sentenceFa: "I, with [Identity Number], on date {date}, have completed the passport identity verification request and am awaiting completion of this verification process.",
    sentenceEn: "I, with [Identity Number], on date {date}, have completed the passport identity verification request and am awaiting completion of this verification process.",
    startBtn: "Start Recording",
    stopBtn: "Stop",
    retryBtn: "Record Again",
    recordedIn: "Recorded in: ",
    statusReady: "Ready to record",
    statusRecording: "Recording... Speak clearly!",
    statusUploadError: "Upload failed",

    // Consent Form translations
    consentTitle: "Review & Consent",
    consentSubtitle: "Final Step: Confirm Your Information",
    formInstruction: "Please fill up the form according to your passport info and passport info only",
    
    // Passport Information Section
    passportInfo: "Passport Information",
    firstName: "First Name",
    lastName: "Last Name",
    dateOfBirth: "Date of Birth",
    sex: "Sex",
    passportNo: "Passport No.",
    country: "Country",
    
    // Gender options
    selectGender: "Select Gender",
    male: "Male",
    female: "Female",
    
    // Terms and Conditions Section
    termsTitle: "Terms and Conditions",
    dataCollection: "Data Collection:",
    dataCollectionText: "By accepting these terms and conditions, you agree to the collection, processing, and storage of your personal information and biometric data for identity verification purposes.",
    dataProtection: "Data Protection:",
    dataProtectionText: "Your data will be processed in accordance with applicable data protection laws and regulations. We implement appropriate technical and organizational measures to protect your information against unauthorized access, alteration, or disclosure.",
    biometricData: "Biometric Data:",
    biometricDataText: "The biometric data collected includes facial recognition data, passport information, and liveness verification video. This data will be used solely for identity verification purposes and will not be shared with third parties without your explicit consent.",
    yourRights: "Your Rights:",
    yourRightsText: "You have the right to access, correct, or delete your personal data at any time by contacting our support team. You may also request a copy of all data we hold about you.",
    privacyPolicy: "Privacy Policy:",
    privacyPolicyText: "For more detailed information about our data handling practices, please refer to our comprehensive Privacy Policy available on our website.",
    
    // Consent checkbox
    consentCheckbox1: "I have fully read and understood the terms and conditions",
    consentCheckbox2: "I consent to the collection, processing, and storage of my biometric data for identity verification purposes as outlined above.",
    
    // Warning
    importantNotice: "Important Notice",
    warningText: "By accepting these terms and conditions, you agree to the collection, processing, and storage of your biometric data. If you decline, you will not be able to proceed with the authentication process.",
    
    // Buttons
    declineBtn: "Decline & Go Back",
    acceptBtn: "Accept & Continue",
    processing: "Processing...",
    
    // Loading
    processingConsent: "Processing Consent",
    loadingText: "Please wait while we finalize your verification...",
    loadingSubtext: "This will only take a moment",
    
    // Placeholders
    firstNamePlaceholder: "Enter first name",
    lastNamePlaceholder: "Enter last name",
    passportNoPlaceholder: "A12345678",
    countryPlaceholder: "e.g., Iran, USA"
  },
  
  fa: {
    // Existing translations
    faceVerification: "احراز هویت چهره",
    passportVerification: "تأیید گذرنامه",
    nationalIdLabel: "شماره کد ملی",
    nationalIdPlaceholder: "کد ملی خود را وارد کنید",
    enterNationalId: "لطفاً کد ملی را وارد کنید",
    startLiveness: "شروع بررسی زنده‌بودن",
    capturePhoto: "ثبت تصویر",
    nextStep: "مرحله بعد: تأیید گذرنامه",
    retry: "تلاش مجدد",
    challengeTitle: "چالش زنده‌بودن",
    challengeListTitle: "پیشرفت چالش",
    turnLeft: "سر خود را به چپ بچرخانید",
    turnRight: "سر خود را به راست بچرخانید",
    blinkTwice: "دو بار پلک بزنید",
    keepTurning: "ادامه دهید!",
    blinksProgress: "پلک زدن:",
    initializing: "راه‌اندازی دوربین...",
    loading: "بارگذاری مدل...",
    ready: "آماده! کد ملی را وارد کنید",
    noFace: "چهره‌ای یافت نشد",
    challengeComplete: "چالش کامل شد!",
    allComplete: "همه بررسی‌ها موفق!",
    uploading: "بارگذاری...",
    success: "احراز هویت موفق!",
    failed: "احراز هویت ناموفق",
    timeout: "زمان تمام شد! دوباره تلاش کنید",
    cameraError: "دسترسی به دوربین رد شد",
    yaw: "چرخش",
    pitch: "خم شدگی",
    roll: "کج شدگی",
    blinks: "پلک",
    
    title: "ضبط گذرنامه",
    subtitle: "گذرنامه خود را برای تأیید اسکن کنید",
    instructionsTitle: "دستورالعمل‌ها",
    instruction1: "گذرنامه خود را روی سطحی صاف و با نور کافی قرار دهید",
    instruction2: "از دوربین استفاده کنید یا تصویر بارگذاری کنید",
    instruction3: "در صورت نیاز، جعبه‌های قرمز (عکس) و آبی (MRZ) را تنظیم کنید",
    instruction4: "عکس بگیرید و برای تأیید ارسال کنید",
    captureBtn: "ضبط",
    uploadBtn: "بارگذاری",
    submitBtn: "ارسال",
    statusInit: "دوربین آماده است. گذرنامه را قرار دهید.",
    statusCapturing: "در حال گرفتن تصویر...",
    statusProcessing: "در حال پردازش بارگذاری...",
    statusSubmitting: "در حال ارسال برای تأیید...",
    statusSuccess: "تأیید موفق!",
    statusCameraError: "خطا در دوربین",
    previewTitle: "پیش‌نمایش - بررسی و ارسال",
    
    livenessTitle: "تأیید زنده‌بودن",
    livenessSubtitle: "مرحله 3 از 3: ضبط ویدیو تأیید",
    recordingLangLabel: "زبان ضبط:",
    instrTitle: "دستورالعمل‌ها:",
    instructions: [
      "متن زیر را با صدای بلند و واضح بخوانید",
      "مطمئن شوید چهره شما در کادر قابل مشاهده است",
      "محیط ساکت و نورپردازی مناسب داشته باشید",
      "ضبط تا 30 ثانیه ادامه دارد",
      "می‌توانید چند بار امتحان کنید تا راضی شوید",
      "توجه: متن را به زبانی که انتخاب کرده‌اید بخوانید"
    ],
    sentenceFa: "اینجانب [نام شما] درخواست احراز هویت در فنفیکس را دارم.",
    sentenceEn: "I [Your Name] request identity verification at Fenefx.",
    startBtn: "شروع ضبط",
    stopBtn: "توقف",
    retryBtn: "ضبط مجدد",
    recordedIn: "ضبط شده به زبان: ",
    statusReady: "آماده ضبط",
    statusRecording: "در حال ضبط... واضح صحبت کنید!",
    statusUploadError: "آپلود ناموفق بود",

    // Consent Form translations
    consentTitle: "بررسی و رضایت",
    consentSubtitle: "مرحله نهایی: تأیید اطلاعات شما",
    formInstruction: "لطفا اطلاعات فرم را مطابق با اطلاعات پاسپورت خود پر کنید",
    
    // Passport Information Section
    passportInfo: "اطلاعات گذرنامه",
    firstName: "نام",
    lastName: "نام خانوادگی",
    dateOfBirth: "تاریخ تولد",
    sex: "جنسیت",
    passportNo: "شماره پاسپورت",
    country: "کشور",
    
    // Gender options
    selectGender: "انتخاب کنید",
    male: "مرد",
    female: "زن",
    
    // Terms and Conditions Section
    termsTitle: "شرایط و ضوابط",
    dataCollection: "جمع‌آوری داده:",
    dataCollectionText: "با پذیرش این شرایط و ضوابط، شما با جمع‌آوری، پردازش و ذخیره‌سازی اطلاعات شخصی و داده‌های بیومتریک خود برای اهداف احراز هویت موافقت می‌کنید.",
    dataProtection: "حفاظت از داده:",
    dataProtectionText: "داده‌های شما مطابق با قوانین و مقررات حفاظت از داده‌ها پردازش خواهند شد. ما اقدامات فنی و سازمانی مناسب را برای محافظت از اطلاعات شما در برابر دسترسی، تغییر یا افشای غیرمجاز اجرا می‌کنیم.",
    biometricData: "داده‌های بیومتریک:",
    biometricDataText: "داده‌های بیومتریک جمع‌آوری شده شامل داده‌های تشخیص چهره، اطلاعات گذرنامه و ویدیوی تأیید زنده‌بودن است. این داده‌ها صرفاً برای اهداف احراز هویت استفاده خواهند شد و بدون رضایت صریح شما با اشخاص ثالث به اشتراک گذاشته نخواهند شد.",
    yourRights: "حقوق شما:",
    yourRightsText: "شما این حق را دارید که در هر زمان با تماس با تیم پشتیبانی ما به داده‌های شخصی خود دسترسی داشته باشید، آن‌ها را تصحیح یا حذف کنید. همچنین می‌توانید درخواست کپی از تمام داده‌هایی که از شما نگهداری می‌کنیم را داشته باشید.",
    privacyPolicy: "سیاست حفظ حریم خصوصی:",
    privacyPolicyText: "برای اطلاعات دقیق‌تر در مورد روش‌های مدیریت داده‌های ما، لطفاً به سیاست حفظ حریم خصوصی جامع ما که در وب‌سایت ما موجود است، مراجعه کنید.",
    
    // Consent checkbox
    consentCheckbox1: "من شرایط و ضوابط را به طور کامل خوانده و درک کرده‌ام",
    consentCheckbox2: "من با جمع‌آوری، پردازش و ذخیره‌سازی داده‌های بیومتریک خود برای اهداف احراز هویت همانطور که در بالا ذکر شد، موافقم.",
    
    // Warning
    importantNotice: "اطلاعیه مهم",
    warningText: "با پذیرش این شرایط و ضوابط، شما با جمع‌آوری، پردازش و ذخیره‌سازی داده‌های بیومتریک خود موافقت می‌کنید. اگر رد کنید، نمی‌توانید با فرآیند احراز هویت ادامه دهید.",
    
    // Buttons
    declineBtn: "رد کردن و بازگشت",
    acceptBtn: "قبول و ادامه",
    processing: "در حال پردازش...",
    
    // Loading
    processingConsent: "پردازش رضایت",
    loadingText: "لطفاً صبر کنید تا احراز هویت شما نهایی شود...",
    loadingSubtext: "این فقط یک لحظه طول می‌کشد",
    
    // Placeholders (keep in English as requested)
    firstNamePlaceholder: "Enter first name",
    lastNamePlaceholder: "Enter last name",
    passportNoPlaceholder: "A12345678",
    countryPlaceholder: "e.g., Iran, USA"
  },
  
  ar: {
    // Existing translations
    faceVerification: "التحقق من الوجه",
    passportVerification: "التحقق من جواز السفر",
    nationalIdLabel: "رقم الهوية الوطنية",
    nationalIdPlaceholder: "أدخل رقم هويتك الوطنية",
    enterNationalId: "يرجى إدخال رقم الهوية الوطنية",
    startLiveness: "ابدأ فحص الحيوية",
    capturePhoto: "التقاط الصورة",
    nextStep: "الخطوة التالية: التحقق من جواز السفر",
    retry: "إعادة المحاولة",
    challengeTitle: "تحدي الحيوية",
    challengeListTitle: "تقدم التحدي",
    turnLeft: "أدر رأسك إلى اليسار",
    turnRight: "أدر رأسك إلى اليمين",
    blinkTwice: "أرمش مرتين",
    keepTurning: "استمر في الدوران!",
    blinksProgress: "الرمشات:",
    initializing: "تهيئة الكاميرا...",
    loading: "تحميل النموذج...",
    ready: "جاهز! أدخل رقم الهوية وابدأ",
    noFace: "لم يتم اكتشاف وجه",
    challengeComplete: "اكتمل التحدي!",
    allComplete: "اجتازت جميع الفحوصات!",
    uploading: "جاري الرفع...",
    success: "نجح التحقق!",
    failed: "فشل التحقق",
    timeout: "انتهى الوقت! حاول مرة أخرى",
    cameraError: "تم رفض الوصول إلى الكاميرا",
    yaw: "الانعراج",
    pitch: "الميل",
    roll: "الدوران",
    blinks: "الرمشات",
    
    title: "التقاط جواز السفر",
    subtitle: "امسح جواز سفرك للتحقق",
    instructionsTitle: "التعليمات",
    instruction1: "ضع جواز سفرك على سطح مستوٍ ومضاء جيدًا",
    instruction2: "استخدم الكاميرا أو حمّل صورة",
    instruction3: "اضبط المربعات الحمراء (الصورة) والزرقاء (MRZ) إذا لزم الأمر",
    instruction4: "التقط وأرسل للتحقق",
    captureBtn: "التقاط",
    uploadBtn: "تحميل",
    submitBtn: "إرسال",
    statusInit: "الكاميرا جاهزة. ضع جواز سفرك.",
    statusCapturing: "جاري التقاط الصورة...",
    statusProcessing: "جاري معالجة التحميل...",
    statusSubmitting: "جاري الإرسال للتحقق...",
    statusSuccess: "نجح التحقق!",
    statusCameraError: "خطأ في الكاميرا",
    previewTitle: "معاينة - تحقق وأرسل",
    
    livenessTitle: "التحقق من الحيوية",
    livenessSubtitle: "الخطوة 3 من 3: تسجيل الفيديو",
    recordingLangLabel: "لغة التسجيل:",
    instrTitle: "التعليمات:",
    instructions: [
      "اقرأ النص أدناه بوضوح وبصوت عالٍ",
      "تأكد من أن وجهك مرئي في الإطار",
      "استخدم بيئة هادئة مع إضاءة جيدة",
      "سيستمر التسجيل حتى 30 ثانية",
      "يمكنك إعادة المحاولة عدة مرات حتى تكون راضيًا",
      "ملاحظة: اقرأ النص باللغة التي اخترتها"
    ],
    sentenceFa: "أنا، برقم [رقم الهوية]، بتاريخ {date}، قد أكملت طلب التحقق من هوية جواز السفر وأنتظر إكمال عملية التحقق هذه.",
    sentenceEn: "I, with [Identity Number], on date {date}, have completed the passport identity verification request and am awaiting completion of this verification process.",
    startBtn: "بدء التسجيل",
    stopBtn: "إيقاف",
    retryBtn: "تسجيل مرة أخرى",
    recordedIn: "تم التسجيل بلغة: ",
    statusReady: "جاهز للتسجيل",
    statusRecording: "جاري التسجيل... تحدث بوضوح!",
    statusUploadError: "فشل التحميل",

    // Consent Form translations
    consentTitle: "المراجعة والموافقة",
    consentSubtitle: "الخطوة الأخيرة: تأكيد معلوماتك",
    formInstruction: "يرجى ملء النموذج وفقًا لمعلومات جواز سفرك فقط",
    
    // Passport Information Section
    passportInfo: "معلومات جواز السفر",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    dateOfBirth: "تاريخ الميلاد",
    sex: "الجنس",
    passportNo: "رقم جواز السفر",
    country: "البلد",
    
    // Gender options
    selectGender: "اختر الجنس",
    male: "ذكر",
    female: "أنثى",
    
    // Terms and Conditions Section
    termsTitle: "الشروط والأحكام",
    dataCollection: "جمع البيانات:",
    dataCollectionText: "بقبولك لهذه الشروط والأحكام، فإنك توافق على جمع ومعالجة وتخزين معلوماتك الشخصية وبياناتك البيومترية لأغراض التحقق من الهوية.",
    dataProtection: "حماية البيانات:",
    dataProtectionText: "ستتم معالجة بياناتك وفقًا لقوانين ولوائح حماية البيانات المعمول بها. نحن نطبق التدابير التقنية والتنظيمية المناسبة لحماية معلوماتك من الوصول أو التغيير أو الكشف غير المصرح به.",
    biometricData: "البيانات البيومترية:",
    biometricDataText: "تتضمن البيانات البيومترية المجمعة بيانات التعرف على الوجه ومعلومات جواز السفر وفيديو التحقق من الحيوية. سيتم استخدام هذه البيانات فقط لأغراض التحقق من الهوية ولن تتم مشاركتها مع أطراف ثالثة دون موافقتك الصريحة.",
    yourRights: "حقوقك:",
    yourRightsText: "لديك الحق في الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها في أي وقت عن طريق الاتصال بفريق الدعم لدينا. يمكنك أيضًا طلب نسخة من جميع البيانات التي نحتفظ بها عنك.",
    privacyPolicy: "سياسة الخصوصية:",
    privacyPolicyText: "لمزيد من المعلومات التفصيلية حول ممارسات معالجة البيانات لدينا، يرجى الرجوع إلى سياسة الخصوصية الشاملة المتاحة على موقعنا الإلكتروني.",
    
    // Consent checkbox
    consentCheckbox1: "لقد قرأت وفهمت الشروط والأحكام بالكامل",
    consentCheckbox2: "أوافق على جمع ومعالجة وتخزين بياناتي البيومترية لأغراض التحقق من الهوية كما هو موضح أعلاه.",
    
    // Warning
    importantNotice: "إشعار مهم",
    warningText: "بقبولك لهذه الشروط والأحكام، فإنك توافق على جمع ومعالجة وتخزين بياناتك البيومترية. إذا رفضت، فلن تتمكن من المتابعة في عملية المصادقة.",
    
    // Buttons
    declineBtn: "رفض والعودة",
    acceptBtn: "قبول والمتابعة",
    processing: "جاري المعالجة...",
    
    // Loading
    processingConsent: "معالجة الموافقة",
    loadingText: "يرجى الانتظار بينما نقوم بإنهاء التحقق الخاص بك...",
    loadingSubtext: "سيستغرق هذا لحظة فقط",
    
    // Placeholders (keep in English as requested)
    firstNamePlaceholder: "Enter first name",
    lastNamePlaceholder: "Enter last name",
    passportNoPlaceholder: "A12345678",
    countryPlaceholder: "e.g., Iran, USA"
  }
};